
import BaseModel from "../base_model.js";
import I18n from "../../base/i18n.js.jsx";
import uuidv4 from 'uuid/v4';
import { AddressModel } from "../addresses/address.js";
import { CompanyPersonModel } from "./company_person_model.js";

class RawCompanyModel extends BaseModel {

  rawListFields() {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        sortKey: "name"
      },
      {
        name: "createdAt",
        displayName: this.fieldDisplayName("createdAt"),
        type: "dateTime",
        dateFormat: "DD.MM.YYYY",
        timeFormat: "HH:mm",
        sortKey: "created_at"
      },
    ]
  }


  rawFormFields(item = undefined) {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        forceNextLine: true,
        required: true
      },
      {
        name: "address",
        type: "nestedModel",
        weight: 12,
        fields: (parentField, item) => {
          const fields = AddressModel.formFields({item: item});
          const whiteList = ["city", "postalCode", "street", "number"];
          return fields.filter(field => whiteList.includes(field.name))
                       .map(field => {
                         field.disableAutoComplete = true;
                         return field;
                       });
        }
      },
      {
        name: "people",
        type: "nestedModelsArray",
        weight: 12,
        itemWeight: 12,
        defaultWeight: 6,
        allowDragDrop: false,
        allowDelete: true,
        fields: (parentField, item) => {
          return CompanyPersonModel.formFields({item: item});
        },
        defaultItem: (items) => {
          return {
            clientId: uuidv4(),
          }
        }
      },
    ]
  }

  displayValue(item) {
    if(!item) {
      return "";
    }
    if(!item.id) {
      return I18n.t(`${this.i18nScope()}.new`);
    }
    if(!item.name) {
      return `${I18n.t(`${this.i18nScope()}.name`, {count: 1} )} ${item.id}`;
    }
    return item.name;
  }

  i18nScope() {
    return "model.companies.company";
  }

  value(item) {
    if(!item) {
      return undefined;
    }
    return item.id;
  }

}
const CompanyModel = new RawCompanyModel();

export { RawCompanyModel, CompanyModel }

